import router from './router'
import store from './store'
import { getToken,getRollback } from '@/utile/auth'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false })

const whiteList = ['/']

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/') {
      next({ path: getRollback() });
      NProgress.done()
    } else {
      if(store.getters.addRouters.length==0){
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          // router.addRoutes(store.getters.addRouters);
          if(to.meta.role&&to.meta.role.length>0){
            sessionStorage.setItem('btnPermissions',JSON.stringify(to.meta.role));
          }else{
            sessionStorage.setItem('btnPermissions',null);
          };
          next({ ...to,replace:true })
        })
        .catch((err) => {
          next();
        })
      }else{
        if(to.meta.role&&to.meta.role.length>0){
          sessionStorage.setItem('btnPermissions',JSON.stringify(to.meta.role));
        }else{
          sessionStorage.setItem('btnPermissions',null);
        }
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({ path: '/' })
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
/**处理vue路由出现 Loading chunk {n} failed 的问题   */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  }
});



// WEBPACK FOOTER //
// ./src/permission.js